<template>
  <el-dialog
    :title="$t('activitiesManage.signup.title') + ' - ' + activityTitle"
    :visible.sync="dialogVisible"
    width="900px"
    @close="handleClose"
    custom-class="activities-signup-dialog"
  >
    <div class="dialog-toolbar">
      <el-button type="primary" size="small" @click="_loadSignUps">
        <i class="el-icon-refresh"></i>
        {{ $t('activitiesManage.signup.refresh') }}
      </el-button>
      <el-button type="success" size="small" @click="handleExport">
        <i class="el-icon-download"></i>
        {{ $t('activitiesManage.signup.export') }}
      </el-button>
    </div>
    <el-table
      ref="signUpTable"
      :data="signUps"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column type="index" label="#" width="50" align="center" />
      <el-table-column
        prop="ownerName"
        :label="$t('activitiesManage.signup.ownerName')"
        align="center"
      />
      <el-table-column
        prop="link"
        :label="$t('activitiesManage.signup.link')"
        align="center"
      />
      <el-table-column
        prop="unitNum"
        :label="$t('activitiesManage.signup.unitNum')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.unitNum || scope.row.unitNumName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="floorNum"
        :label="$t('activitiesManage.signup.floorNum')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.floorNum || scope.row.floorLayer || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="roomNum"
        :label="$t('activitiesManage.signup.roomNum')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.roomNum || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="roomName"
        :label="$t('activitiesManage.signup.roomName')"
        align="center"
      />
      <el-table-column
        prop="createTime"
        :label="$t('activitiesManage.signup.createTime')"
        align="center"
        width="170"
      />
    </el-table>
    <el-pagination
      v-if="total > 0"
      :current-page.sync="page.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="page.size"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      style="margin-top: 15px; text-align: right"
    />
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { listActivitiesSignUps } from '@/api/oa/activitiesManageApi'
import * as XLSX from 'xlsx'

export default {
  name: 'ActivitiesSignUpDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      activityId: '',
      activityTitle: '',
      signUps: [],
      total: 0,
      page: {
        current: 1,
        size: 20
      }
    }
  },
  methods: {
    open(row) {
      this.activityId = row.activitiesId
      this.activityTitle = row.title || ''
      this.dialogVisible = true
      this.page.current = 1
      this._loadSignUps()
    },
    async _loadSignUps() {
      this.loading = true
      try {
        const params = {
          activitiesId: this.activityId,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listActivitiesSignUps(params)
        this.signUps = data || []
        this.total = total || 0
      } catch (error) {
        console.error('获取报名人员失败:', error) // eslint-disable-line no-console
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this._loadSignUps()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._loadSignUps()
    },
    handleExport() {
      if (this.signUps.length === 0) {
        this.$message.warning(this.$t('activitiesManage.signup.noData'))
        return
      }
      const exportData = this.signUps.map((item, index) => ({
        '序号': index + 1,
        '业主姓名': item.ownerName || '',
        '手机号': item.link || '',
        '单元号': item.unitNum || item.unitNumName || '-',
        '楼层': item.floorNum || item.floorLayer || '-',
        '房间号': item.roomNum || '-',
        '完整门牌号': item.roomName || '-',
        '报名时间': item.createTime || ''
      }))

      const ws = XLSX.utils.json_to_sheet(exportData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '报名人员')

      ws['!cols'] = [
        { wch: 6 },
        { wch: 12 },
        { wch: 15 },
        { wch: 10 },
        { wch: 8 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 }
      ]

      const fileName = `${this.activityTitle}_报名人员_${new Date().toLocaleDateString()}.xlsx`
      XLSX.writeFile(wb, fileName)
    },
    handleClose() {
      this.signUps = []
      this.total = 0
      this.page.current = 1
      this.activityId = ''
      this.activityTitle = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-toolbar {
  margin-bottom: 15px;
}
</style>
